<template>
  <v-breadcrumbs class="pl-0" :items="breadcrumbs"></v-breadcrumbs>
</template>

<script>
  export default {
    name: 'Breadcrumbs',
    props: {
      breadcrumbs: Array
    }
  }
</script>
